export const SOFTLINE_PERMISSION_WERKSTAETTENAUFTRAG_ARBEITSBERICHT = 'GARAGE_TIMEREPORT';
export const SOFTLINE_PERMISSION_WERKSTAETTENAUFTRAG_ARBEITSBERICHT_LOESCHEN = 'GARAGE_TIMEREPORT.DELETE';
export const SOFTLINE_PERMISSION_WERKSTAETTENAUFTRAG_ARBEITSBERICHT_ERSTELLEN = 'GARAGE_TIMEREPORT.CREATE';
export const SOFTLINE_PERMISSION_WERKSTAETTENAUFTRAG = 'GARAGEORDER';
